<template>
    <v-row class="fill-height">
        <v-col class="pt-0 pb-0">
            <v-tabs
              fixed-tabs
              background-color="#003a6f"
              dark
              v-model="tab"
            >
              <v-tab>
                Construction
              </v-tab>
              <v-tab>
                Cleaning
              </v-tab>
              <v-tab>
                Service
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item
              >
                <v-card
                  color="basil"
                  flat
                >
                  <Construction />
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  color="basil"
                  flat
                >
                  <Cleaning />
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  color="basil"
                  flat
                >
                  <Service />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
        </v-col>
    </v-row>
</template>

<script>
import Construction from '../components/Calendar/Construction.vue'
import Cleaning from '../components/Calendar/Cleaning.vue'
import Service from '../components/Calendar/Service.vue'

export default {
  data: () => ({
    tab: null,
    loading: false,
  }),
  components: {
    Construction,
    Cleaning,
    Service
  },
}
</script>

<style lang="sass">
.v-calendar .v-event
    white-space: normal!important
    height: auto!important

    div 
      white-space: normal
      text-align: center
      padding: 6px!important
</style>